var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBroadcastMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 24,
    height: 24,
    rx: 12,
    stroke: "#898E99",
    strokeWidth: 4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3566_64010)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9745 19.1392C13.2321 19.1392 12.5709 19.0116 11.9909 18.7564C11.4142 18.4979 10.9584 18.1432 10.6237 17.6925C10.2922 17.2384 10.1215 16.7147 10.1116 16.1214H12.2792C12.2925 16.37 12.3737 16.5888 12.5228 16.7777C12.6753 16.9633 12.8775 17.1075 13.1294 17.2102C13.3812 17.313 13.6646 17.3643 13.9795 17.3643C14.3076 17.3643 14.5976 17.3063 14.8495 17.1903C15.1014 17.0743 15.2986 16.9136 15.4411 16.7081C15.5837 16.5026 15.6549 16.2656 15.6549 15.9972C15.6549 15.7254 15.5787 15.4851 15.4262 15.2763C15.2771 15.0642 15.0616 14.8984 14.7799 14.7791C14.5015 14.6598 14.1701 14.6001 13.7856 14.6001H12.836V13.0192H13.7856C14.1104 13.0192 14.3971 12.9628 14.6457 12.8501C14.8976 12.7375 15.0931 12.5817 15.2323 12.3828C15.3715 12.1806 15.4411 11.9453 15.4411 11.6768C15.4411 11.4216 15.3798 11.1979 15.2572 11.0057C15.1379 10.8101 14.9688 10.6577 14.7501 10.5483C14.5347 10.4389 14.2828 10.3842 13.9944 10.3842C13.7027 10.3842 13.4359 10.4373 13.194 10.5433C12.952 10.6461 12.7581 10.7936 12.6123 10.9858C12.4665 11.178 12.3886 11.4034 12.3786 11.6619H10.3154C10.3254 11.0753 10.4927 10.5582 10.8176 10.1108C11.1424 9.66335 11.5799 9.31368 12.1301 9.06179C12.6836 8.80658 13.3083 8.67898 14.0044 8.67898C14.707 8.67898 15.3218 8.80658 15.8488 9.06179C16.3758 9.317 16.7851 9.66169 17.0768 10.0959C17.3718 10.5268 17.5176 11.0107 17.5143 11.5476C17.5176 12.1177 17.3403 12.5933 16.9823 12.9744C16.6277 13.3556 16.1653 13.5975 15.5953 13.7003V13.7798C16.3443 13.8759 16.9144 14.1361 17.3055 14.5604C17.6999 14.9813 17.8954 15.5083 17.8921 16.1413C17.8954 16.7214 17.7281 17.2367 17.39 17.6875C17.0553 18.1383 16.5929 18.4929 16.0029 18.7514C15.413 19.0099 14.7368 19.1392 13.9745 19.1392Z",
    fill: "#898E99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3566_64010"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 22,
    fill: "white",
    transform: "translate(9 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBroadcastMessage);
export default __webpack_public_path__ + "static/media/BroadcastMessage.34de4f98a5a42784c97773edceeb5868.svg";
export { ForwardRef as ReactComponent };